import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { uniq } from "lodash";
import MerchandiseDetails from "./merchandiseDetails";

function MerchandiseForm(props) {
  const merchandiseLineItems = useSelector((state) =>  state.InvoicesReducer.invoices[props.invoiceItemIndex].merchandiseList||[]);

  let uniquemerch = uniq(merchandiseLineItems);
  const {
    invoiceId,
    invoiceItemIndex,
    isFormDisabled,
    totalItem,
    shipmentETA,
    translate,
    jobWheels
  } = props;

 

  const printMerchandise = uniquemerch.map((item, index) => (
    <MerchandiseDetails
      key={item.merchandiseId}
      invoiceIndex={invoiceItemIndex}
      invoiceId={invoiceId}
      lineItemIndex={index}
      counter={index + 1}
      totalLineItems={totalItem}
      isFormDisabled={isFormDisabled}
      shipmentETA={shipmentETA}
      translate={translate}
      jobWheels={jobWheels}
    />
  ))

  const MerchandiseList = useMemo(
    () => printMerchandise,
    [merchandiseLineItems.length,isFormDisabled,translate,]
  );

  return <>{MerchandiseList}</>;
}
export default React.memo(MerchandiseForm)
